import _ from 'lodash';
import client from './RestClient';
import { AxiosInstance } from 'axios';

export interface CountryWebService {
  getPublisherCountry(): Promise<Array<string>>;
}

export class RestfulCountryWebService implements CountryWebService {
  restClient: AxiosInstance;

  constructor(restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async getPublisherCountry(): Promise<Array<string>> {
    const resp = await this.restClient.get('/spaceCountries');
    return _.defaults(resp.data, []);
  }
}
